import React from "react";
import HomeHero from "./HomeHero";
import TrustedByBrands from "./TrustedByBrands";
import WeAreArsh from "./WeAreArsh";
import TrustedPaper from "./TrustedPaper";
import WhatTheySay from "./WhatTheySay";

const Home: React.FC = () => {
  return (
    <div className="font-sans bg-[#FFFDF8]">
      <HomeHero />
      <TrustedByBrands />
      <WeAreArsh />
      <TrustedPaper />
      <WhatTheySay />
    </div>
  );
};

export default Home;